/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.com/docs/browser-apis/
 */

import { navBarStatusChange } from './src/common/bridge'

import 'normalize.css'
import './src/global.css'

// 非生产环境才展示, 且以白名单的方式, 避免意外部署导致显示
const enableVConsole = () => {
  import('vconsole').then(m => {
    const VConsole = m.default
    new VConsole()
  })
}

if (
  ['qa', 'eu-qa', 'sqa', 'ci', 'smoke', 'stress'].includes(
    process.env.GATSBY_DEPLOY_ENV
  )
) {
  enableVConsole()
}

if (typeof window !== 'undefined') {
  const host = window.location.hostname
  if (host === 'localhost' || host === '127.0.0.1' || /^\d+\.\d+\.\d+\.\d+$/.test(host)) {
    enableVConsole()
  }
}

// pr 环境下, anker 内部邮箱也展示 vconsole 便于排查问题
if (process.env.GATSBY_DEPLOY_ENV === 'pr') {
  import('./src/common/bridge').then(({ getNativeInfo }) => {
    getNativeInfo()
      .then(info => {
        const email = (info?.email || '').toLowerCase()
        if (email.endsWith('@anker-in.com') || email.endsWith('@anker.com')) {
          enableVConsole()
        }
      })
      .catch(() => {})
  })
}

// const isSSR = typeof window === 'undefined'
// const isDevelopment = process.env.NODE_ENV === 'development'

export const onClientEntry = () => {
  window.addEventListener('pageshow', () => {
    navBarStatusChange({
      hideNavbar: true,
    })
  })
}
